import type { Program } from 'models';
import { useCallback, useMemo } from 'react';
import { Modal, message } from 'ui';
import { useCreateAbuseReportMutation } from 'features/report';

export const useConfirmReportProgram = () => {
  const [modal, contextHolder] = Modal.useModal();

  const { mutate: createAbuseReport } = useCreateAbuseReportMutation();

  const confirmReportProgram = useCallback(
    (program: Program) => {
      modal.confirm({
        onOk() {
          createAbuseReport(
            { programId: program.id },
            {
              onSuccess() {
                message.success('Successfully reported.');
              },
            },
          );
        },
        title: 'Are you sure you want to report this program?',
      });
    },
    [createAbuseReport, modal],
  );

  return useMemo(() => ({ confirmReportProgram, contextHolder }), [confirmReportProgram, contextHolder]);
};
